import { render, staticRenderFns } from "./ed-filter-template.component.vue?vue&type=template&id=35857cb1&scoped=true&"
import script from "./ed-filter-template.component.ts?vue&type=script&lang=ts&"
export * from "./ed-filter-template.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-filter-template.component.scss?vue&type=style&index=0&id=35857cb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35857cb1",
  null
  
)

export default component.exports